import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";
import "./styles.css";
import { Badge } from "primereact/badge";
import { Score } from "../../components/Score";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import bullet from "highcharts/modules/bullet";
import RespostaInsumoPage from "../consulta/resposta/RespostaInsumo";
import { formatarParaMoedaBRL } from "../../utils";
bullet(Highcharts);
export default function ResultadoPropostaCreditoPage({
    resultado,
    onClose,
  }: {
    resultado: any;
    onClose: any;
  }) {

    const { t } = useTranslation();
    const ajuste = (chart:any) => {
        let elements = document.getElementsByClassName('highcharts-plot-band ')
           
            Array.prototype.forEach.call(elements, function(element) {
               element.setAttribute('d', 'M 9.5 10 A 8.75 8.75 0 1 0 9.5 55 L 540.5 55 A 5.75 5.75 1 1 0 540.5 10 Z');
            });
           elements = document.getElementsByClassName('highcharts-root')
           elements[1].setAttribute('viewBox', '0 0 500 115');
           
           
       
    }

    const getRange = (pontuacao:number) => {
        
        if(pontuacao >= 400 && pontuacao < 500){
            return 'REGULAR'
        }

        if(pontuacao >= 500 && pontuacao < 600){
            return 'BOM'
        }
        if(pontuacao >= 600){
            return 'OTIMO'
        }

        return 'RUIM'
    }

    const options = {
    
        chart: {
            inverted: true,
            type: 'bullet',
            height: '100',
            width: 550,
            events: {
                render: function(){
                    ajuste(this)
                }
            }
           
        },
        title: {
            text: null
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            
            series: {
                lineWidth: 0,
                grouping: false,
                pointPadding: 0.25,
                borderRadius: 10,
                borderWidth: 0
            },
            column: {
      stacking: 'normal',
      borderWidth: 0,
      dataLabels: {
        enabled: true,
        color: 'white'
      }
    }
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
      
      
        xAxis: {
            lineWidth: '0',
            categories: ['']
        },
        tooltip:{
          enabled: false   
        },
        yAxis: {
          gridLineWidth: 0,
          startOnTick: false,
            max:resultado.resultados.length,
            
            plotBands: [{
                
                color: {
                    linearGradient: { x1: 0, y1: 1, x2: 1, y2: 1 },
                    stops: [
                        [0, '#DE1616'],
                       [0.5, '#FFCA39'],
                       [1, '#0DAB01']
                    ]
                },
                from: 0,
                to: resultado.resultados.length
            }],
            title: null
        },
        series: [{
           
            data: [{
                y: parseInt(resultado.resultados.filter((s:any) => s.status !== 'Não Aplicado').length),
                color: '#F5F5DC'
            }],
     
        }]
      
      
      };

    return (
        <div>
            <Card className="card-proposta-credito">
                <div className="grid">
                    <div className="col p-fluid flex flex-wrap">
                        <h2>{resultado.nome}</h2>
                    </div>
                     <div style={{alignContent:"end", padding: '1.8rem'}}>
                        <div className="row-proposta-credito" >
                            <div className="column-proposta-credito">
                            <span style={{fontWeight: '500'}}>Documento: {resultado.documento}</span>
                            </div>
                        </div>
                        <div className="row-proposta-credito" >
                            <div className="column-proposta-credito">
                                <span style={{fontWeight: '500'}}>Situação receita federal: </span><Badge className={resultado.statusDocumento === 'IRREGULAR' || resultado.statusDocumento === 'BAIXADO' ? 'status-badge-erro' : 'status-badge-registrado'} value={resultado.statusDocumento}></Badge>
                            </div>
                        </div>
                     </div>
                </div>
            </Card>
            <br></br>
            <div className="card">
                <div className="grid">
                <div className="scrScore col">
                    <Score
                        score={resultado.pontuacao ?  resultado.pontuacao : 0}
                        range={getRange(resultado.pontuacao ?  resultado.pontuacao : 0)}
                    />
                </div>
                <div>
                    <Card className="card-proposta-credito" style={{height: '300px'}}>
                        <div className="grid" >
                            <div className="col" style={{display: 'grid', justifyContent: 'center'}}>
                                <Card style={{width:'15rem', height: '13.8rem'}}>
                                    <div style={{textAlign: 'center'}}>
                                        {resultado.status === 'Reprovado' ? (
                                            <div style={{display: 'grid', textAlign: 'center',paddingTop: '1rem'}}>
                                                <div className="row-proposta-credito" >
                                                    <div className="column-proposta-credito">
                                                        <i style={{color:'#DE1616', fontSize: '35'}} className="pi pi-thumbs-down"></i>
                                                    </div>
                                                </div>
                                                <div style={{paddingTop: '1rem'}} className="row-proposta-credito" >
                                                    <div className="column-proposta-credito">
                                                        <span style={{fontWeight: '550', color: '#DE1616'}}>Negociação Não Recomendada</span>
                                                    </div>
                                                </div>
                                                <div style={{paddingTop: '1rem'}} className="row-proposta-credito" >
                                                    <div className="column-proposta-credito">
                                                        <span style={{fontWeight: '350', color: '#DE1616', fontSize: '12'}}>De acordo com o perfil do cliente,
                                                        você não deve seguir com a negociação.</span>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            resultado.status === 'Operação Manual' ? (
                                            <div style={{display: 'grid', textAlign: 'center', paddingTop: '1rem'}}>
                                                <div className="row-proposta-credito" >
                                                    <div className="column-proposta-credito">
                                                        <i style={{color:'#FF8C00', fontSize: '35'}} className="pi pi-question-circle"></i>
                                                    </div>
                                                </div>
                                                <div style={{paddingTop: '1rem'}} className="row-proposta-credito" >
                                                    <div className="column-proposta-credito">
                                                        <span style={{fontWeight: '550', color: '#FF8C00'}}>Negociação Análise Manual</span>
                                                    </div>
                                                </div>
                                                <div style={{paddingTop: '1rem'}} className="row-proposta-credito" >
                                                    <div className="column-proposta-credito">
                                                        <span style={{fontWeight: '350', color: '#FF8C00', fontSize: '12'}}>Sistema não idenficicou o perfil do cliente necessitando uma análise manual.</span>
                                                    </div>
                                                </div>
                                            </div>
                                            ) : (
                                            <div style={{display: 'grid', textAlign: 'center', paddingTop: '1rem'}}>
                                                <div className="row-proposta-credito" >
                                                    <div className="column-proposta-credito">
                                                        <i style={{color:'green', fontSize: '35'}} className="pi pi-thumbs-up"></i>
                                                    </div>
                                                </div>
                                                <div style={{paddingTop: '1rem'}} className="row-proposta-credito" >
                                                    <div className="column-proposta-credito">
                                                        <span style={{fontWeight: '550', color: 'green'}}>Negociação Recomendada</span>
                                                    </div>
                                                </div>
                                                <div style={{paddingTop: '1rem'}} className="row-proposta-credito" >
                                                    <div className="column-proposta-credito">
                                                        <span style={{fontWeight: '350', color: 'green', fontSize: '12'}}>De acordo com o perfil do cliente,
                                                        você pode seguir com a negociação.</span>
                                                    </div>
                                                </div>
                                            </div>
                                            ))}
                                        
                                            
                                    </div> 
                                </Card>
                            </div>
                            <div className="col">
                                <div className="row-proposta-credito" >
                                    <div className="column-proposta-credito">
                                        <div>
                                            <span style={{fontSize: '12'}}>Limite de parcela mensal sugerida</span>
                                            <Card style={{ height: '5rem'}}>
                                                <span style={{fontWeight: '550'}}>Valor de Limite de Crédito
                                                Disponível</span>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                                <div style={{paddingTop: '2rem'}} className="row-proposta-credito" >
                                    <div className="column-proposta-credito">
                                        <div>
                                            <span style={{fontSize: '12'}}>Sugestão de negociação</span>
                                            <Card style={{height: '5rem'}}>
                                            <span style={{fontWeight: '550', visibility:'hidden'}}>Valor de Limite de Crédito
                                            Disponível</span>
                                                <span style={{fontWeight: '550', textAlign: 'left'}}>{resultado.resultadoMotorCreditoItem?.valorSugerido ? formatarParaMoedaBRL(resultado.resultadoMotorCreditoItem?.valorSugerido) : 'R$ 0,00' }</span>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br></br>
                        <span style={{fontSize: '12', paddingTop: '1rem'}}>Sempre verifique os outros indicadores antes de tomar a sua decisão.</span>
                    </Card>
                </div>
                </div>
            </div>
            <br></br>
            <div className="card"  style={{ display: "flex"}}>
               <div className="grid" style={{width: '100%'}}>
                   <div className="col">
                    <Card className="card-proposta-credito" style={{height: '100%', display: 'flex', textAlign: 'center', justifyContent: 'center'}}>
                        <span style={{fontWeight:'850',fontSize: '22'}}>Regras executadas</span>
                        <Card>
                            <div className="grid">
                                <div className="col">
                                    {resultado.resultados.map((item:any) => (
                                        <div className="flex-score align-items-center justify-content-between ">
                                            <span style={{color:'#183462'}} className="block font-bold  mb-3">{item.regra}</span>
                                            <div style={{paddingLeft: '1rem'}} className="flex-score align-items-center justify-content-between h-2rem border-round">
                                                <span style={{backgroundColor : item.status === 'Aprovado' ? '#0DAB01' : (item.status === 'Reprovado' ? '#DE1616' : (item.status === 'Não Utilizado' ? '#FFCA39' : (item.status === 'Indisponível' ? '#fa9e06' : '')))}} className={'dot-regra mb-3'}></span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Card>
                    </Card>
                   </div>
                   <div className="col" style={{width:'65%'}}>
                    <Card className="card-proposta-credito" style={{height: '100%', display: 'flex', textAlign: 'center', justifyContent: 'center'}}>
                        <span style={{fontWeight:'850',fontSize: '22'}}>Gráfico regras executadas</span>
                        <Card>
                            <HighchartsReact highcharts={Highcharts} options={options} />
                        </Card>
                    </Card>
                   </div>
               </div>
            </div>
            <Panel header='Resultado Proposta Crédito'>
               
              <br></br>
              <DataTable size="small" value={resultado.resultados} tableStyle={{ minWidth: '50rem' }}>
                  <Column field="regra" header={t('regra')}></Column>
                  <Column field="valorObtido" header={t('valorObtido')}></Column>
                  <Column field="operador" header={t('operador')}></Column>
                  <Column field="valorEsperado" header={t('valorEsperado')}></Column>
                  <Column field="status" header={t('status')}></Column>
                  <Column field="pontuacao" header={t('pontuacao')}></Column>
              </DataTable>
            </Panel>
            <br></br>
            {resultado.respostas.map((resposta: any, index: string) => (<RespostaInsumoPage key={'resp_' + index} resposta={resposta}></RespostaInsumoPage>))}
            
        </div>
    )
  }